import { Protocol } from '../Protocol';

export class NameProtocol {
  public static readonly ALL_NAMES: string = `${Protocol.YATUNG_API_ROOT}/name/all`;
}
